import EmpresaMapper from "@/features/contabil/common/EmpresaMapperAdapter";
import { IIndiceModelResponse, IIndicesResponse } from "../../requests/types";

export default class Indices {
  constructor(readonly response: IIndicesResponse | undefined) {}

  getLegenda(): string[] {
    const response = this.response;

    if (!response) return [];

    const anos = response.empresas
      .map((empresa) => Object.keys(empresa.indices))
      .flat()
      .sort();

    return [...new Set(anos)];
  }

  getSeries(indicador: keyof IIndiceModelResponse = "ebtida") {
    const response = this.response;

    if (!response) return [];

    const anosOrdenados = this.getLegenda();
    const indices = response.empresas.map((empresa) => ({
      empresa: EmpresaMapper.toEntity(empresa),
      data: anosOrdenados.map((ano) =>
        empresa.indices[ano] ? empresa.indices[ano][indicador] : null
      )
    }));

    return indices;
  }
}
